// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Kt8u","insightsList":"newBusinessInsightsMenu_insightsList__1rl6x","active":"newBusinessInsightsMenu_active__1kLaf"};